import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export const sendAdvisoryNow = (dataDestService: any, componentDataSourceService: ComponentDataSourceService) => {
  return (adviId: number): Observable<any> => {
    
    return dataDestService.http.post(
      `${environment.apiUrl}/advi/${adviId}/send-now`,
      {}
    ).pipe(
      catchError(error => {
        console.error('[sendAdvisoryNow] Error response:', error);
        throw error;
      })
    );
  };
};
